// eslint-disable-next-line import/prefer-default-export
export const TOGGLE_OPEN_CONTACT_MODAL = 'TOGGLE_OPEN_CONTACT_MODAL';
export const TOGGLE_OPEN_MEMBER_MODAL = 'TOGGLE_OPEN_MEMBER_MODAL';
export const SET_MEMBER_MODAL = 'SET_MEMBER_MODAL';
export const TOGGLE_OPEN_MEETING_MODAL = 'TOGGLE_OPEN_MEETING_MODAL';
